import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgTranscludeDirective } from './ng-transclude.directive';
import { TabHeadingDirective } from './tab-heading.directive';
import { TabDirective } from './tab.directive';
import { TabsetComponent } from './tabset.component';
import { TabsetConfig } from './tabset.config';
var TabsModule = (function () {
    function TabsModule() {
    }
    TabsModule.forRoot = function () {
        return {
            ngModule: TabsModule,
            providers: [TabsetConfig]
        };
    };
    TabsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [NgTranscludeDirective, TabDirective, TabsetComponent, TabHeadingDirective],
                    exports: [TabDirective, TabsetComponent, TabHeadingDirective, NgTranscludeDirective]
                },] },
    ];
    /** @nocollapse */
    TabsModule.ctorParameters = function () { return []; };
    return TabsModule;
}());
export { TabsModule };
//# sourceMappingURL=tabs.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/tabs/tabs.module.js
// module id = 457
// module chunks = 42